/**
 * Hariom ERP - Authentication State Store (Zustand)
 * Manages login state, user session, and token persistence
 */
import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { User } from '../types'

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;

  // Actions
  setUser: (user: User, token: string) => void;
  logout: () => void;
  setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      isLoading: false,

      /** Called after successful login */
      setUser: (user, token) => set({
        user,
        token,
        isAuthenticated: true,
        isLoading: false,
      }),

      /** Clear session on logout */
      logout: () => set({
        user: null,
        token: null,
        isAuthenticated: false,
      }),

      setLoading: (loading) => set({ isLoading: loading }),
    }),
    {
      name: 'hariom-erp-auth',    // localStorage key
      partialize: (state) => ({    // only persist token + user, not loading
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
)
